import { SearchProjectsRequest } from "../../service/publicquery";
import { FilterGroup } from "../../service/Shared";

type SearchProjectsFilter = NonNullable<SearchProjectsRequest["filter"]>;

export const getDefaultInvestmentDirectoryProjectFilterGroups = (): FilterGroup<SearchProjectsFilter>[] => [
  {
    operator: "or",
    filterGroups: [
      {
        operator: "and",
        filter: {
          results: {
            listing: {
              seekingFunding: {
                operator: "eq",
                value: true,
              },
            },
          },
        },
      },
      {
        operator: "and",
        filter: {
          results: {
            listing: {
              availableForSale: {
                operator: "eq",
                value: true,
              },
            },
          },
        },
      },
    ],
  },
];
